import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import About from "@/pages/About";

export const Route = createFileRoute("/zh-cn/about-qbd/")({
  head: () => buildRouteHead("/zh-cn/about-qbd"),
  component: About,
});

